export const INCENTIVES_MARKET_CONTRACT_UNIT_TAGS = {
  NUM: 'MERCADO_NUM_UNIDADES',
  CLASS: 'MERCADO_CLASE_UNIDADES',
  PRICE: 'MERCADO_PRECIO_UNIDAD',
} as const;

/** Legacy share terminology — kept for templates created before unit rename */
export const LEGACY_INCENTIVES_MARKET_CONTRACT_UNIT_TAGS = {
  NUM: 'MERCADO_NUM_ACCIONES',
  CLASS: 'MERCADO_CLASE_ACCIONES',
  PRICE: 'MERCADO_PRECIO_ACCION',
} as const;
